<template>
    <div style="background-color: #f5f5f5;">
        <div class="banner2">
            <img src="../assets/img/banner7.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="job">
                    <h2>{{ title }}</h2>
                    <form @submit.prevent="SearchForm">
                        <input type="text" class="input" v-model="form.zhiwei" placeholder="输入职位关键词" /><button class="button">搜索职位</button></form>
                    <div class="list1">
                        <div class="list" v-show="article.node04 == 'Y'" v-for="(article, index) in article_list" :key="index" :id="article.id" @click.stop="article_view(article.id,zplb)">
                            <span>
                                <div class="t">{{ article.zhiwei }}</div>
                                <div class="c"><p>{{ article.zwlb }}</p>|<p>{{ article.diqu }}</p></div>
                            </span>
                        </div>
                    </div>

                    <a href="javascript:void(0);" class="more" @click.stop="article_all(zplb)">查看更多职位</a>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { XiaoYuanZhaoPin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '校园招聘',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list:'',
            zplb: 701,

            form:{
                zhiwei:'',
            },
            //翻页
            pageNum: 1, //当前页
            pageSize: 6, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页

        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.XiaoYuanZhaoPin_data( this.form.zhiwei, this.pageNum, this.pageSize );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        SearchForm(){
            //console.log(JSON.stringify(this.form));
            this.XiaoYuanZhaoPin_data( this.form.zhiwei, this.pageNum, this.pageSize );
        },
        article_view( id, zplb ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "JobView",
                query: { id: id, zplb: zplb },
            });
        },
        article_all( zplb ) {  //带uuid跳转详情页面
            this.$router.push({
                path: "JobList",
                query: { zplb: zplb },
            });
        },
        XiaoYuanZhaoPin_data( zhiwei, pageNum, pageSize ){ //文章分类显示
            XiaoYuanZhaoPin({
                zhiwei: zhiwei, //职位
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                this.article_list = res.rows;
            });
        },
    },
};
</script>
<style lang="less" scoped>
.job{
    width:1200px;
    margin:20px auto;
    text-align:center;
}
.job h2{
    font-size:30px;
    color:#333;
    display:block;
    font-weight:normal;
}
.job form{
    width:790px;margin:0px auto;border:1px solid #e9e9e9;height:40px;line-height:40px;
}
.job form .input{
    width:626px;height:38px;line-height:38px;border:0px solid #000;vertical-align:top;outline:none;
    text-indent: 10px;
}
.job form .button{
    width:160px;background-color:#d6000f;cursor:pointer;;color:#fff;height:40px;line-height:40px;border:0px solid #000;vertical-align:top;outline:none;
}
.job .list1{
    margin:30px auto;
    zoom:1;
    overflow:auto;
}
.job .list1 .list{
    float:left;
    width:33.3333333%;
}
.job .list1 .list span{
    cursor: pointer;
    position: relative;
    margin:10px auto;
    display:inline-block;
    width:390px;
    height:140px;
    background-color:#fff;
}
.job .list1 .list span:after{
    position: absolute;
    content: '';
    left:0px;
    bottom:0px;
    width: 0%;
    height:3px;
    background-color: #d6000f;
}
.job .list1 .list span:hover:after{
	animation: span_after_hover 0.3s linear forwards;
}
@keyframes span_after_hover {
	0% {
		width: 0%;
	}
	100% {
		width: 100%;
	}
}

.job .list1 .list span:hover{
    box-shadow: 0px 0px 10px rgba(0,0,0,0.2);
}
.job .list1 .list span .t{
    text-align:left;margin:0px 30px;height:60px;line-height:60px;font-size:20px;
}

.job .list1 .list span .t i{
    display: inline-block;
    width:20px;
    height:20px;
    line-height:20px;
    font-size:14px;
    color:#fff;
    background-color: #d6000f;
    font-style: normal;
    text-align: center;
    font-size:14px;
    vertical-align: top;
    margin:20px 5px 0px 0px;
}
.job .list1 .list span .c{
    text-align: left;
    margin:20px 30px 10px 20px;
    height:40px;line-height:40px;
    color:#ccc;
}
.job .list1 .list span .c p{
    display: inline-block;
    padding: 0px 10px;
    font-size: 14px;
    color:#999;
}
.job .more{
    width:160px;display:inline-block;text-align:center;text-decoration:none;margin:0px auto;background-color:#d6000f;cursor:pointer;;color:#fff;height:38px;line-height:38px;border:0px solid #000;vertical-align:top;outline:none;
}

</style>



// WEBPACK FOOTER //
// src/pages/XiaoYuanZhaoPin.vue